<template>
  <div class="container flex w-full flex-col lg:flex-row lg:gap-5">
    <!-- Desktop image gallery -->
    <div class="order-2 hidden w-full lg:order-1 lg:block lg:w-3/5">
      <ImageGallery />
    </div>

    <div
      id="configurator-container-wrapper"
      class="order-3 flex h-fit w-full flex-col rounded-xl lg:w-2/5 lg:border lg:border-gray-ultralight lg:py-4"
    >
      <!-- Mobile and desktop page title -->
      <PageTitle />

      <!-- Mobile image gallery -->
      <div class="mt-3 block w-full lg:hidden lg:w-3/5">
        <ImageGallery />
      </div>

      <!-- Mobile and desktop product info block -->
      <SimpleProductInfo v-if="props.isSimpleProduct" />
      <ProductInfo v-else />
    </div>
  </div>
</template>

<script setup lang="ts">
import PageTitle from '@/pages/ProductPage/partials/ProductDetailPage/PageTitle.vue';
import ImageGallery from '@/pages/ProductPage/partials/ProductDetailPage/ImageGallery.vue';
import ProductInfo from '@/pages/ProductPage/partials/ProductInfo.vue';
import SimpleProductInfo from '@/pages/ProductPage/partials/SimpleProductInfo.vue';

const props = defineProps({
  isSimpleProduct: {
    type: Boolean,
    required: true,
    default: false,
  },
});
</script>
